<div
  class="game-card"
  (click)="onClick($event)"
  [ngClass]="gameName"
  @fadeSlideInOut
>
  <!-- game background image -->
  <div class="game-card__background">
    <img
      [src]="getBackgroundImageUrl"
      fzSrcError="/shared/img/all-sports.webp"
    />
  </div>

  <div class="game-card__root">
    <!-- game shared action -->
    <button
      matTooltip="Share tournament"
      mat-button
      class="game-card__button share-button"
      color="primary"
      (click)="onShare($event)"
    >
      <mat-icon data-ga-value="game-card-share-button">share</mat-icon> Share
    </button>

    <!-- game tag -->
    <div class="game-card__tag" *ngIf="cardRightTag">
      <ng-container *ngTemplateOutlet="cardRightTag"></ng-container>
    </div>

    <div
      class="game-card__content"
      [ngClass]="{
        let: tournament?.lifeExperience === true,
        casual: tournament?.lifeExperience !== true
      }"
    >
      <div class="game-card__header">
        <div class="game-card__header__game-avatar">
          <img
            loading="lazy"
            class="game-image"
            [src]="getGameImageUrl"
            fzSrcError="/shared/img/all-sports.webp"
          />
        </div>
        <div class="game-card__header__title">
          <span class="mat-headline-6">{{ tournament?.name }}</span>
        </div>
      </div>
      <div class="game-card__extra" *ngIf="!disableExtraData">
        <ng-content></ng-content>
      </div>

      <!-- new option to show prize range
        TODO: refactor tournament-list component to use this version instead
      -->
      <ng-content
        select="fz-game-card-prize, [fz-game-card-prize], [fzGameCardPrize]"
      ></ng-content>

      <ng-content
        select="fz-game-card-prize-description, [fz-game-card-prize-description], [fzGameCardPrizeDescription]"
      ></ng-content>

      <!-- tournaments time -->
      <ng-content
        select="fz-game-card-time, [fz-game-card-time], [fzGameCardTime]"
      ></ng-content>

      <!-- tournaments type -->
      <ng-content
        select="fz-game-card-tags, [fz-game-card-tags], [fzGameCardTags]"
      ></ng-content>
    </div>
  </div>
</div>
